/**
 * The product name. Brief constraint 2 and architecture §16.6: this is the only place the name
 * appears in code; UI, titles and emails import it (a lint rule bans the literal elsewhere).
 */
export const PRODUCT_NAME = 'Quadratic' as const;

export type ProductName = typeof PRODUCT_NAME;
